export const teacherDashboardEndpoints = {
  login: '/login',
  oauthLogin: '/login-oauth'
};
